// Salary calculation now uses paid_factor from company.statuses
// pay_type === "fixed" => uses absolute fixed_amount KZT per day (replaces dailyRate × paid_factor)
import { statusesAsMap, entryKey } from "../constants";

export function computeStats(entries, uid, calendarDays, statuses) {
  const map = statusesAsMap(statuses);
  let planned = 0, marked = 0, paidDays = 0, fixedTotal = 0;
  const counts = {}; // key -> count
  for (const dStr of Object.keys(calendarDays || {})) {
    const day = parseInt(dStr, 10);
    const cal = calendarDays[dStr];
    if (cal === "work" || cal === "short") planned += 1;
    const e = entries?.[entryKey(uid, day)];
    if (!e) continue;
    marked += 1;
    counts[e.status] = (counts[e.status] || 0) + 1;
    const st = map[e.status];
    if (st?.pay_type === "fixed") {
      fixedTotal += Number(st.fixed_amount) || 0;
    } else {
      paidDays += st?.paid_factor ?? 0;
    }
  }
  return {
    planned, marked, counts, paidDays, fixedTotal,
    // Convenience aliases for known keys
    worked: counts.work || 0,
    halfday: counts.halfday || 0,
    sick: counts.sick || 0,
    absent: counts.absent || 0,
    vacation: counts.vacation || 0,
    trip: counts.business_trip || 0,
  };
}

export function calcSalary({ monthlySalary, normWorkDays, paidDays, fixedTotal = 0 }) {
  if (!normWorkDays || normWorkDays <= 0) {
    return { dailyRate: 0, gross: Math.round(fixedTotal * 100) / 100 };
  }
  const dailyRate = monthlySalary / normWorkDays;
  const gross = dailyRate * paidDays + fixedTotal;
  return {
    dailyRate: Math.round(dailyRate * 100) / 100,
    gross: Math.round(gross * 100) / 100,
  };
}
